/**=========================================================
 * Module: fb.js
 * Chat Controller
 =========================================================*/

 App.controller('AppmessagesController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService',
  'Restangular', 'DataService', 'ngDialog', '$filter', 'toaster', '$http',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog, $filter, toaster, $http) {
   "use strict";

    $scope.page = {
      title: 'App Messages'
    };

    $scope.types = [ 'overlay', 'header' ];
    $scope.roles = [ 'GUEST', 'ADMIN', 'CLIENT', 'SUPPLIER', 'USER', 'SUPERUSER' ];
    $scope.classes = ['success','warning','danger','info'];
    $scope.languages = ['it_IT','en_GB','de_DE'];

    var newMessage =  {
      show: false,
      id: '',
      type: '',
      roles: {'GUEST':false, 'ADMIN':false, 'CLIENT':false, 'SUPPLIER':false, 'USER':false, 'SUPERUSER':false},
      cls: '',
      message: {'it_IT':'','en_GB':'','de_DE':''},
      title: {'it_IT':'','en_GB':'','de_DE':''},
      isNew: true
    };

    $scope.messages = [];

    FIREBASE.listen('app', 'messages', function(values){
      $scope.messages = [];
      for(var id in values){
        $scope.messages.push(values[id]);
      }
      $scope.messages.push(JSON.parse(JSON.stringify(newMessage)));
    }, null, { doNotUnsubscribe: true, interval: 300000 });

    $scope.saveMessage = function(m){
      $http.put($rootScope.app.config.baseUrl + '/action/SaveAppMessage', m).then(function(resp){});
    }
    $scope.deleteMessage = function(m){
      $http.put($rootScope.app.config.baseUrl + '/action/DeleteAppMessage', m).then(function(resp){});
    }


 }]);
